import clsx from "clsx";
import { DefaultComponentProps } from "@/interfaces/common";
import { ColorsName } from "../Button";

type Colors = ColorsName;

interface Props extends Omit<DefaultComponentProps, "children"> {
  color?: Colors;
  size?: number;
  stroke?: number;
}

export const LoadingSpinner = ({ size = 20, stroke = 4, color = "primary", className }: Props): JSX.Element => {
  const colors: Record<Colors, string> = {
    white: "var(--white)",
    primary: "var(--primary)",
    secondary: "var(--loading-secondary)",
    error: "var(--loading-destructive)",
  };

  const colorValue = colors[color];

  return (
    <div
      className={clsx("relative", className)}
      style={{
        width: size,
        height: size,
      }}
    >
      <div
        className="absolute inset-0 animate-spin rounded-full"
        style={{
          background: `conic-gradient(from 90deg, rgba(75, 122, 157, 0) 0deg, ${colorValue} 0.95deg, rgba(232, 238, 242, 0.87) 132.5deg, rgba(75, 122, 157, 0) 360deg)`,
        }}
      />
      <div
        className="absolute rounded-full"
        style={{
          inset: stroke,
          backgroundColor: color === "white" ? "#58876A" : "#fff",
        }}
      />
    </div>
  );
};
